import { type MutationPayload } from 'vuex';
import Store from '../stores/store';
import { NearestClubModuleConstant } from '../constants';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export default class NearestClubStore implements ltFramework.INearestClubStore {
	public getInitialData(): ltFramework.INearestClubStoreData {
		return (Store.state as ltFramework.IStoreState).nearestClubModule.store;
	}

	public listen(callback: (state: ltFramework.INearestClubStoreData) => void): () => void {
		return Store.subscribe((mutation: MutationPayload, state: ltFramework.IRootState) => {
			if (mutation.type.includes(NearestClubModuleConstant.name + '/')) {
				callback((state as ltFramework.IStoreState).nearestClubModule.store);
			}
		});
	}

	public searchForNearestClubs(payload: ltFramework.INearestClubSearchAction): Promise<void> {
		return Store.dispatch(
			NearestClubModuleConstant.name + '/' + NearestClubModuleConstant.action.searchForNearestClubs,
			payload
		);
	}
}
